module.exports = __webpack_public_path__ + "media/track_guides/video_placeholder-e5b9e8bd.png";